import store from 'services/redux/store'
import { dataConstants } from 'services/redux/data/constants'
import { useEffect, useState } from 'react'
import _ from 'lodash'
import PushNotificationService from 'services/push-notifications/service'
import HelperAlerts from 'utils/HelperAlerts'
import i18n from 'utils/i18n'

const PushNotificationsProvider = ({ children }) => {
	
	const _employee = store.getState().data[ dataConstants.EMPLOYEE ];
	
	const [ checked, setChecked ] = useState( false )
	
	const validatePushNotification = async() => {
		// set checked here already to true, so we don't ask again
		setChecked( true )
		
		if( await PushNotificationService.isAvailable() ) {
			// Get the current status and check if we have permission to send notifications
			const settings = await PushNotificationService.getCurrentPermissions()
			if( await PushNotificationService.canAskPermission( settings ) ) {
				// Ask if we may send notifications
				HelperAlerts.alert(
					null,
					i18n.t( 'notifications.request_text' ),
					[
						{
							text: i18n.t( 'buttons.ok' ),
							onPress: () => {
								PushNotificationService.register()
									.then( async( { token }) => {
										PushNotificationService.mutate( token )
									})
									.catch( e => {
										console.log('testy5', 'error', e );
									})
							}
						}
					]
				);
				
				return
			}
			
			// Mutate existing?
			if( PushNotificationService.isPermissionGranted( settings ) ) {
				
				try {
					// Get the token
					const { token } = await PushNotificationService.getToken()
					
					// Mutate the token!
					PushNotificationService.mutate( token )
				} catch ( e ) {
					console.log('testy5', 'error', e );
				}
			}
		}
	}
	
	useEffect( () => {
		if( !checked && !_.isEmpty( _employee ) ) {
			validatePushNotification().finally( () => {
				setChecked( true )
			})
		}
	}, [ _employee ] );
	
	return children
}

export default PushNotificationsProvider
